import { FormPDFEditor } from './FormPDFEditor';

export default FormPDFEditor;
